// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3JBFD","colMaxWidth":"Table_colMaxWidth__zCC42"};